module.exports = __webpack_public_path__ + "static/media/card-b2c.61612f0e.png";